<shared-toolbar title="Grupos de puestos de trabajo">
  @if (isSysAdmin) {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <mat-select
        [disabled]="!ValidBusiness_id()"
        (selectionChange)="chargueData()"
        [(value)]="selectedBussines">
        @for (item of bussines; track item) {
          <mat-option [value]="item.idBusiness">{{ item.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
  <shared-button
    (click)="modalAction()"
    [typeBtn]="'button'"
    [color]="'accent'"
    [icon]="'add'"
    >Agregar
  </shared-button>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</th>
        <td mat-cell *matCellDef="let element">
          {{ element.description }}
        </td>
      </ng-container>

      <ng-container class="flex justify-content-center" matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="modalAction(element)">
              <mat-icon mat-icon-button>edit</mat-icon>
              <span>Editar</span>
            </a>
            <a mat-menu-item (click)="modalDelete(element)">
              <mat-icon mat-icon-button color="warn">delete</mat-icon>
              <span>Eliminar</span>
            </a>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
  </mat-card-content>
</mat-card>
